import { Select as BaseSelect, SelectItem } from '@mantine/core';

export default function Select({
  name,
  value,
  label,
  placeholder,
  required,
  error,
  clearable = false,
  options,
  onChange,
}: {
  name?: string;
  value?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: any;
  clearable?: boolean;
  options: (string | SelectItem)[];
  onChange?: (value: string) => void;
}) {
  return (
    <BaseSelect
      name={name}
      value={value}
      label={label}
      placeholder={placeholder}
      required={required}
      error={error}
      clearable={clearable}
      onChange={onChange}
      data={options}
    />
  );
}
